import React from 'react'
import { useEffect, useState } from 'react';
import Check from '../../images/check.svg';
import { getURLSearchParam, LoadingIndicator } from '../../lib/iprs-react-library/src/index';

const PaymentSuccess = ({ nextURL, api, token }) => {

    const [facilityId, setFacilityId] = useState('')
    const [selectedSlot, setSelectedSlot] = useState('')
    const [makeReferralError, setMakeReferralError] = useState('');
    const [isMakeReferralLoading, setIsMakeReferralLoading] = useState(false)
    const [facilityName, setFacilityName] = useState('');
    const [Address, setAddress] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [appointmentDate, setAppointmentDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [isMakeReferralSuccess, setIsMakeReferralSuccess] = useState(false)

    const Spinner = () => {
        const loaderCssOverride = {
            borderColor: "rgb(255 210 239 / 66%) rgb(255 210 239 / 66%) #dd6cae"
        };

        return (
            <div className="loader">
                <LoadingIndicator
                    loading={true}
                    color={"#BD5196"}
                    speed={0.5}
                    size={42}
                    cssOverride={loaderCssOverride}
                />
                <p style={{ marginTop: "26px" }}>Please wait...</p>
            </div>
        );
    };

    useEffect(() => {
        const urlParamFacilityId = getURLSearchParam('FacilityID');
        setFacilityId(urlParamFacilityId);
        const urlParamFacilityName = getURLSearchParam('FacilityName');
        setFacilityName(urlParamFacilityName);
        const urlParamAddress = getURLSearchParam('Address');
        let fullAddress = "";
        try {
            const parsedAddress = JSON.parse(decodeURIComponent(urlParamAddress));

            if (typeof parsedAddress === "object" && parsedAddress !== null) {
                fullAddress = [
                    parsedAddress.Address1,
                    parsedAddress.Address2,
                    parsedAddress.Address3,
                    parsedAddress.Postcode
                ].filter(Boolean).join(", ");
            } else {
                fullAddress = parsedAddress;
            }

        } catch (e) {
            console.error("Failed to parse address:", e);
            setAddress(urlParamAddress);
        }
        setAddress(fullAddress);
        const urlParamSelectedSlot = getURLSearchParam('selectedSlot'); if (urlParamSelectedSlot) {
            try {
                const parsedSlot = JSON.parse(decodeURIComponent(urlParamSelectedSlot));
                setSelectedSlot(parsedSlot);
                // Convert UTC times to UK time and format to 12-hour AM/PM
                if (parsedSlot.startDateTime) {
                    const startUK = toUKTime(parsedSlot.startDateTime);
                    const startFormatted = new Intl.DateTimeFormat("en-GB", {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                        timeZone: "Europe/London"
                    }).format(new Date(parsedSlot.startDateTime));
                    setStartTime(startFormatted);
                }

                if (parsedSlot.endDateTime) {
                    const endUK = toUKTime(parsedSlot.endDateTime);
                    const endFormatted = new Intl.DateTimeFormat("en-GB", {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                        timeZone: "Europe/London"
                    }).format(new Date(parsedSlot.endDateTime));
                    setEndTime(endFormatted);
                }

                if (parsedSlot.startDateTime) {
                    const ukDate = new Intl.DateTimeFormat("en-GB", {
                        timeZone: "Europe/London",
                        year: "numeric",
                        month: "long",
                        day: "2-digit"
                    }).format(new Date(parsedSlot.startDateTime));
                    setAppointmentDate(ukDate);
                }
            } catch (e) {
                console.error("Failed to parse selectedSlot from URL:", e);
                setSelectedSlot(null);
            }
        } else {
            setSelectedSlot(null);
        }

    }, []);

    const toUKTime = (dateString) => {
        return new Intl.DateTimeFormat("en-GB", {
            timeZone: "Europe/London",
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        }).format(new Date(dateString));
    };

    useEffect(() => {
        if (facilityId) {
            setLoading(true);
            confirmClinic(token, facilityId)
            setLoading(false);
        }
    }, [facilityId]);
    // Redirecting to feedback page after making an API call
    const apiMakeReferral = (token, facilityId) => {
        setMakeReferralError('');
        setIsMakeReferralLoading(true);
        const params = {
            "Token": token,
            "FacilityID": facilityId,
            SelectedSlot: selectedSlot !== undefined ? selectedSlot : null
        }
        api.transact("MakeReferral", params)
            .then(r => {
                setIsMakeReferralLoading(false);
                setIsMakeReferralSuccess(true);
                console.log("MakeReferral: ", r)
            })
            .catch(error => {
                setIsMakeReferralLoading(false);
                console.log(error)
                if (error.apiText !== undefined) {
                    setMakeReferralError(error.apiText);
                }
            });
    }

    const confirmClinic = () => {
        apiMakeReferral(token, facilityId);
        setIsMakeReferralLoading(true);
    }
    const redirectToThankYouPage = () => {
        const urlForFeedBack = '../feedback/'
            + '?Token=' + token
            + '&FacilityID=' + facilityId
            + '&SelectedSlot=' + encodeURIComponent(JSON.stringify(selectedSlot ?? null))
        window.location.replace(urlForFeedBack);
    }

    return (
        <form>
            <div
                className='form__group paymentMessage'
                style={{
                    padding: '30px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignContent: 'center'
                }}
            >
                <img
                    src={Check}
                    alt='Check icon'
                    style={{
                        width: '100px',
                        margin: 'auto',
                        marginBottom: '20px'
                    }}
                />
                <div
                    className="form__title"
                    style={{
                        marginBottom: '10px'
                    }}
                >
                    <h2
                        style={{
                            color: '#B8397A',
                            margin: '0.75em 0',
                            fontWeight: '600',
                            fontSize: '150%'
                        }}
                    >Your payment card was authenticated.</h2>
                </div>
                <p
                    style={{
                        paddingBottom: '20px',
                        paddingLeft: '20px',
                        paddingRight: '20px'
                    }}
                >
                    Thank you, your payment card was successfully authenticated.<br />
                </p>
                <div className="booking-summary">
                    <h3>Booking Summary</h3>
                    <div className="row">
                        <span className="label">Clinic Name:</span>
                        <span className="value">{facilityName}</span>
                    </div>
                    <div className="row">
                        <span className="label">Clinic Address:</span>
                        <span className="value">{Address}</span>
                    </div>

                    {selectedSlot && (
                        <>
                            <div className="row">
                                <span className="label">Date:</span>
                                <span className="value">{appointmentDate}</span>
                            </div>
                            <div className="row">
                                <span className="label">Time:</span>
                                <span className="value">{startTime} - {endTime}</span>
                            </div>
                        </>
                    )}
                </div>

                <>
                    {isMakeReferralLoading && (
                        <div style={{ marginTop: "10px", textAlign: "center" }}>
                            <LoadingIndicator
                                loading={true}
                                color={"#BD5196"}
                                size={42}
                            />
                            <p style={{ marginTop: "12px" }}>Please wait...</p>
                        </div>
                    )}
                    {isMakeReferralSuccess && (
                        <div style={{ marginTop: "10px", textAlign: "center" }}>
                            <button
                                type="button"
                                className="payment form__action"
                                onClick={redirectToThankYouPage}
                                style={{
                                    margin: 'auto',
                                    height: '42px'
                                }}
                            >
                                Next
                            </button>
                        </div>
                    )}

                    {makeReferralError && (
                        <p style={{ marginTop: "20px", color: "red" }}>
                            {makeReferralError}
                        </p>
                    )}
                </>


            </div>
        </form>
    )
}

export default PaymentSuccess